/** Данная ошибка не сбрасывает счётчики isLoading */
export default class RaceConditionError extends Error {
  constructor(message: string = 'Race condition detected, request aborted') {
    super(message);
  }
}
